import { defineMessages } from 'react-intl';

/** i18n for Dailymotion connect alternatives shown in the multi-method dialog. */
export const dailymotionConnectMessages = defineMessages({
  loginName: {
    id: 'socialExport.dailymotion.connect.loginName',
    defaultMessage: 'Cuenta de Dailymotion',
  },
  loginDescription: {
    id: 'socialExport.dailymotion.connect.loginDescription',
    defaultMessage:
      'Te redirigimos a Dailymotion para iniciar sesión y autorizar el acceso a tu canal.',
  },
  apiKeyName: {
    id: 'socialExport.dailymotion.connect.apiKeyName',
    defaultMessage: 'API key privada',
  },
  apiKeyDescription: {
    id: 'socialExport.dailymotion.connect.apiKeyDescription',
    defaultMessage:
      'Ingresá key, secret e ID de canal desde Dailymotion Studio. Ideal para organizaciones.',
  },
});
